import React from "react";

import { useTranslation } from "utils";

import { Button, Flex, Form, Link } from "components";

interface PasswordButtonsProps {
  loading: boolean;
}

export const PasswordButtons = ({ loading }: PasswordButtonsProps) => {
  const { t } = useTranslation("signinup");

  return (
    <Flex vertical gap={32}>
      <Link to="/sign-in" className="link green-text">
        {t("changePassword.buttons.signin")}
      </Link>
      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
          {t("changePassword.buttons.sendEmail")}
        </Button>
      </Form.Item>
    </Flex>
  );
};
